<div class="video-call-invite">
  <p>{{ 'NGX-MESSAGING.youCanJoinTheCallHere' | translate }}</p>
  <button type="button" class="video-call-invite__button" (click)="open()">
    <mat-icon svgIcon="new_videocall"></mat-icon>
    {{ 'NGX-MESSAGING.joinHere' | translate }}
  </button>
</div>
